import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RoutingService } from '@spartacus/core';
import { ItemService } from '@spartacus/organization/administration/components';
import { OrganizationItemStatus } from '@spartacus/organization/administration/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { createOrUpdateBranch, deleteBranch, getUigBranchDetails } from '../store/uig-branches.actions';
import { UigBranchesState } from '../store/uig-branches.reducer';
import { selectUigBranchDetails } from '../store/uig-branches.selectors';
import { Branch, BranchForm, StoreLocatorFeatureGroup } from '../uig-branches/uig-branches.models';
import { UigBranchFormService } from './uig-branch-form.service';
import { UigCurrentBranchService } from './uig-current-branch.service';

@Injectable({
  providedIn: 'root',
})
export class UigBranchesItemService extends ItemService<BranchForm> {

  current$ = this.currentItemService.item$;

  constructor(
    protected currentItemService: UigCurrentBranchService,
    protected routingService: RoutingService,
    protected formService: UigBranchFormService,
    protected store: Store<UigBranchesState>
  ) {
    super(currentItemService, routingService, formService);
  }

  load(name?: string): Observable<BranchForm> {
    this.store.dispatch(getUigBranchDetails({ name }));
    return this.store.select(selectUigBranchDetails).pipe(
      filter((data) => data != null)
    );
  }

  create(value: BranchForm): Observable<OrganizationItemStatus<BranchForm>> {
    // not used, had to implement it 
    return null;
  }

  update(key: string, value: BranchForm): Observable<OrganizationItemStatus<BranchForm>> {
    // not used, had to implement it 
    return null;
  }

  protected getDetailsRoute(): string {
    return 'branchesDetails';
  }

  deleteBranch(name: string) {
    this.store.dispatch(deleteBranch({ name }));
  }

  createOrUpdateBranch(branch: BranchForm) {
    this.store.dispatch(createOrUpdateBranch({ branch }));
  }

  getForm(item?: Branch, features?: StoreLocatorFeatureGroup[]): UntypedFormGroup {
    return this.formService.getForm(item, features);
  }
}